import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    SET_LAST_INPUT_CHANGE_RECORD,
    SelecrSeriesStore,
    SelectActiveSeriesIndex,
    SelectActiveSeriesPartIndex,
    SelectBoxGroup,
    SelectCrossGroup,
    SelectFpGroup,
    SelectLastInputChangeRecord,
    SelectSeriesPart,
    SelectSeriesType,
    SelectSeriesTypeDisableFlag,
    SelectboxValue,
    setBoxValue,
} from "../../../../redux/2d-slice/seriesSlice2d";
import { seriesStore } from "../../../../extra/createState";

function SeriesNumberInput({ seriesField, inputRefs, verticalInputaRefs, setActiveInput, horizontalInputRefs, inputFocus, setInputFocus, boxGropupIndex, setBoxGropupIndex, isMobile, activeButtonValue }) {
    const dispatch = useDispatch();
    const activeSeriesIndex = useSelector(SelectActiveSeriesIndex);
    const activeSeriesPartIndex = useSelector(SelectActiveSeriesPartIndex);
    const FpGroup = useSelector(SelectFpGroup);
    const CrossGroup = useSelector(SelectCrossGroup);
    const BoxGroup = useSelector(SelectBoxGroup);
    const seriesStore = useSelector(SelecrSeriesStore);
    const seriesType = useSelector(SelectSeriesType);
    const boxValue = useSelector(SelectboxValue);

    const [changeFocusNumber] = useState([0, 10, 20, 30, 40, 50, 60, 70, 80, 90]);

    const changeInput = (input, value) => {
        let inputArray = [];

        if (seriesType === "Family") {
            FpGroup[input.index].activeInput.forEach((inputIndex) => {
                const field = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex][inputIndex];
                field.setValue(value);
                inputArray.push(field);
            });

            dispatch(SET_LAST_INPUT_CHANGE_RECORD({ activeSeriesIndex, activeSeriesPartIndex, input: inputArray }));
            return inputArray; // ✅
        }

        else if (seriesType === "Cross") {
            if (CrossGroup[inputFocus]) {
                CrossGroup[input.index].activeInput.forEach((inputIndex) => {
                    const field = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex][inputIndex];
                    field.setValue(value);
                    inputArray.push(field);
                });

                dispatch(SET_LAST_INPUT_CHANGE_RECORD({ activeSeriesIndex, activeSeriesPartIndex, input: inputArray }));
                return inputArray; // ✅
            } else {
                input.setValue(value);
                dispatch(SET_LAST_INPUT_CHANGE_RECORD({ activeSeriesIndex, activeSeriesPartIndex, input }));
                return [input]; // ✅
            }
        }

        else if (seriesType === "Box25") {
            let boxvalueCopy = JSON.parse(JSON.stringify(boxValue));
            boxvalueCopy[boxGropupIndex] = value;
            dispatch(setBoxValue([...boxvalueCopy]));

            let finalValue = (value > 0 && (value.toString().endsWith("0") || value.toString().endsWith("5")))
                ? value / 25
                : 0;

            BoxGroup[boxGropupIndex].activeInput.forEach((inputIndex) => {
                const field = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex][inputIndex];
                field.setValue(finalValue);
                inputArray.push(field);
            });

            dispatch(SET_LAST_INPUT_CHANGE_RECORD({ activeSeriesIndex, activeSeriesPartIndex, input: inputArray }));
            return inputArray; // ✅
        }

        else {
            if (!value) {
                input.resetValue();
                input.setValue(0);
            } else {

                input.setValue(Number(value));

                // Horizontal & Vertical remove
                input.setHorigentalValue(0);
                input.setVerticalValue(0);
            }

            dispatch(
                SET_LAST_INPUT_CHANGE_RECORD({
                    activeSeriesIndex,
                    activeSeriesPartIndex,
                    input
                })
            );

            return [input];
        }
    };

    const inputFocusChange = (e, i) => {
        let { key } = e;
        if (key === "ArrowLeft") {
            if (changeFocusNumber.includes(i)) {
                verticalInputaRefs.current[i / 10]?.focus();
                return;
            }

            if (seriesType === "Odd" || seriesType === "Even") {
                if (changeFocusNumber.includes(i - 1)) {
                    verticalInputaRefs.current[(i - 1) / 10]?.focus();
                } else {
                    inputRefs.current[i - 2]?.focus();
                }

                return;
            }
            inputRefs.current[i - 1]?.focus();
        } else if (key === "ArrowRight") {
            if (changeFocusNumber.includes(i + 1)) {
                verticalInputaRefs.current[(i + 1) / 10]?.focus();
                return;
            }

            if (seriesType === "Odd" || seriesType === "Even") {
                if (changeFocusNumber.includes(i + 2)) {
                    verticalInputaRefs.current[(i + 2) / 10]?.focus();
                } else {
                    inputRefs.current[i + 2]?.focus();
                }
                return;
            }
            inputRefs.current[i + 1]?.focus();
        } else if (key === "ArrowUp") {
            if (i <= 9) {
                horizontalInputRefs.current[i]?.focus();
            } else {
                inputRefs.current[i - 10]?.focus();
            }
        } else if (key === "ArrowDown") {
            inputRefs.current[i + 10]?.focus();
        }
    };

    if (!Array.isArray(seriesField)) {
        return null;
    }

    // allowed keys set for numeric input (digits and control keys)
    const allowedKeys = new Set([
        "Backspace",
        "Tab",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
    ]);

    for (let i = 0; i <= 9; i++) allowedKeys.add(String(i));

    return (
        <React.Fragment>
            {seriesField.map((input, index) => {
                return (
                    <td key={input.index}
                        className={` ${(input.getFinalValue() || (seriesType === "Box25" && boxGropupIndex != null && BoxGroup[boxGropupIndex].activeInput.includes(input.index) && inputFocus === input.index)) && "betfocus"}`}
                    >
                        {/* <div className="bet_no"> {String(input.name).padStart(2, "0")}</div> */}
                        <input

                            style={{
                                height: "30px", width: '100%', textAlign: 'center', border: ' 1px solid black',
                                backgroundColor:
                                    (input.getFinalValue() ||
                                        (seriesType === "Box25" &&
                                            boxGropupIndex != null &&
                                            BoxGroup[boxGropupIndex].activeInput.includes(input.index) &&
                                            inputFocus === input.index))
                                        ? "#dfa7a6"   // active
                                        : "",  // inactive
                            }}
                            className={` 
                                    ${seriesType === "Family" && inputFocus != null && FpGroup[inputFocus].activeInput.includes(input.index) && "active_border"}
                                    ${seriesType === "Cross" && inputFocus != null && CrossGroup[inputFocus]?.activeInput.includes(input.index) && "active_border"}
                                    ${seriesType === "Box25" && boxGropupIndex != null && BoxGroup[boxGropupIndex]?.activeInput.includes(input.index) && "active_border"}
                                    ${seriesType === "Box25" && inputFocus != null && boxGropupIndex != null && BoxGroup[boxGropupIndex]?.activeInput.includes(input.index) && inputFocus !== input.index && "disable_input"}
                                    ${seriesType === "Even" && input.index % 2 !== 0 && "disable_input"}
                                    ${seriesType === "Odd" && input.index % 2 === 0 && "disable_input"}
                                    `}
                            value={(seriesType === "Box25" && boxGropupIndex != null && BoxGroup[boxGropupIndex].activeInput.includes(input.index) && inputFocus === input.index) ? boxValue[boxGropupIndex] || "" : input.getFinalValue() || ""}
                            onChange={(e) => {
                                const v = e.target.value;
                                if (+v > 0 && v.length <= 3) {
                                    changeInput(input, Number(v));
                                } else {
                                    if (!v) changeInput(input, "");
                                }
                            }}
                            placeholder={String(input.name).padStart(2, "0")}
                            ref={(el) => (inputRefs.current[input.index] = el)}
                            onFocus={(e) => {
                                e.target.select();
                                setInputFocus(input.index);

                                // mobile quick button add
                                if (isMobile && activeButtonValue) {

                                    const currentVal = Number(input.getFinalValue()) || 0;
                                    const newVal = currentVal + Number(activeButtonValue);

                                    const fields = changeInput(input, newVal);

                                    // undo support
                                    if (fields && window.pushUndo) {
                                        window.pushUndo(fields);
                                    }

                                    // ✅ focus remove after add
                                    setTimeout(() => {
                                        inputRefs.current[input.index]?.blur();
                                    }, 50);
                                }

                                // box group logic
                                if (index <= 4 && input.index <= 44) {
                                    setBoxGropupIndex(0);
                                } else if (index > 4 && input.index <= 49) {
                                    setBoxGropupIndex(1);
                                } else if (index <= 4 && input.index <= 94) {
                                    setBoxGropupIndex(2);
                                } else if (index > 4 && input.index <= 99) {
                                    setBoxGropupIndex(3);
                                }

                                setActiveInput({
                                    type: "grid",
                                    index: input.index
                                });
                            }}
                            readOnly={isMobile}
                            onClick={(e) => {
                                e.target.select();
                            }}
                            onBlur={() => {
                                setInputFocus(null);
                                setBoxGropupIndex(null);
                            }}
                            onKeyDown={(e) => {

                                // agar digit press hua aur pura text selected hai  
                                if (
                                    /^\d$/.test(e.key) &&
                                    e.target.selectionStart === 0 &&
                                    e.target.selectionEnd === e.target.value.length
                                ) {
                                    changeInput(input, Number(e.key));
                                    e.preventDefault();
                                    return;
                                }

                                if (!allowedKeys.has(e.key) && !/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onKeyUp={(e) => {
                                e.stopPropagation();
                                inputFocusChange(e, input.index);
                            }}
                            disabled={(seriesType === "Odd" && input.index % 2 === 0) || (seriesType === "Even" && input.index % 2 !== 0)}
                        />
                    </td>
                );
            })}
        </React.Fragment>
    );
}


export default SeriesNumberInput;
